// src/services/studentService.jsx
import http from "./http";

/* --------------------------------
   ADD STUDENT
   POST /api/students?action=add
-------------------------------- */
export const addStudent = async (payload) => {
  try {
    const res = await http.post("students?action=add", {
      school_id: payload.school_id,
      name: payload.name,
      roll_no: payload.roll_no,
      student_class: payload.student_class,
      father_name: payload.father_name,
      contact: payload.contact,
      address: payload.address,
      image: payload.image, // Base64 or URL
    });
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   UPDATE STUDENT
   POST /api/students?action=update
-------------------------------- */
export const updateStudent = async (id, payload) => {
  try {
    const res = await http.post("students?action=update", {
      id: id,
      school_id: payload.school_id,
      name: payload.name,
      roll_no: payload.roll_no,
      student_class: payload.student_class,
      father_name: payload.father_name,
      contact: payload.contact,
      address: payload.address,
      image: payload.image,
    });
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   GET ALL STUDENTS FOR A SCHOOL
   POST /api/students?action=get&school_id=...
-------------------------------- */
export const getStudentsBySchool = async (schoolId) => {
  try {
    const res = await http.post(`students?action=get&school_id=${schoolId}`);
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   GET SINGLE STUDENT
   POST /api/students?action=get&id=...
-------------------------------- */
export const getStudentById = async (id) => {
  try {
    const res = await http.post(`students?action=get&id=${id}`);
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   DELETE STUDENT
   POST /api/students?action=delete
-------------------------------- */
export const deleteStudent = async (id) => {
  try {
    const res = await http.post("students?action=delete", {
      id: id,
    });
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};


export const getStudents = async (params = "") => {
  try {
    const res = await http.get(`get_student${params}`);
    return res.data;
  } catch (error) {
    console.log(error?.response?.data);
    return error?.response?.data || {
      status: false,
      message: error.message,
    };
  }
};

export const addStudents = async (data) => {
  try {
    const res = await http.post(
      "add_student",
      data
    );
    return res.data;
  } catch (error) {
    return error?.response?.data || {
      status: false,
      message: error.message,
    };
  }
};

export const updateStudents = async (data) => {
  try {
    const res = await http.post(
      "edit_student",
      data
    );
    return res.data;
  } catch (error) {
    return error?.response?.data || {
      status: false,
      message: error.message,
    };
  }
};

export const deleteStudents = async (id) => {
  try {
    const res = await http.post(
      "delete_student",
      { id }
    );

    return res.data;
  } catch (error) {
    return error?.response?.data || {
      status: false,
      message: error.message,
    };
  }
};

/* --------------------------------
   IMPORT EXCEL STUDENTS
   POST /import_excel_students.php
-------------------------------- */
export const importExcelStudents = async (formData) => {
  try {
    const res = await http.post("import_excel_students.php", formData);
    return res.data;
  } catch (error) {
    return error?.response?.data || {
      status: false,
      message: error?.response?.data?.message || error.message || "Failed to import students",
    };
  }
};

